import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as global from '../../global';
import { API_URL } from "../../../../environments/api-url";

@Injectable({
  providedIn: 'root'
})
export class NoteAddChargeService {
  private isCPTLoaded$ = new BehaviorSubject(false);
  public castIsCPT = this.isCPTLoaded$.asObservable();
  private isICDLoaded$ = new BehaviorSubject(false);
  public castIsICD = this.isICDLoaded$.asObservable();
  constructor(private httpclient: HttpClient) { }

  setisCPT(value) {
    this.isCPTLoaded$.next(value);
  }
  setisICD(value) {
    this.isICDLoaded$.next(value);
  }
  
  checkIfCptAlreadyUsed( query : {}, dateToCompare : {} ) {
    // let dateToCompare = { year: 2023, month: 9, day: 30 };
    return this.httpclient.post(global.url + API_URL.CHARGE.checkIfCptAlreadyUsed, { query , dateToCompare }).pipe()
  }
}
